"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupKioskInteractions = setupKioskInteractions;
/** Page-level kiosk guards. OS/browser escape gestures still require managed kiosk mode. */
function setupKioskInteractions(target = document) {
    let allowExitUntil = 0;
    target.addEventListener('kiosk-exit-requested', () => { allowExitUntil = Date.now() + 60_000; });
    const editable = (event) => event.composedPath().some(node => {
        const el = node;
        return el?.tagName === 'INPUT' || el?.tagName === 'TEXTAREA' || el?.isContentEditable === true;
    });
    const prevent = (event) => { if (event.cancelable)
        event.preventDefault(); };
    target.addEventListener('contextmenu', prevent, { capture: true });
    target.addEventListener('dragstart', prevent, { capture: true });
    target.addEventListener('selectstart', event => { if (!editable(event))
        prevent(event); }, { capture: true });
    target.addEventListener('dblclick', event => { if (!editable(event))
        prevent(event); }, { capture: true });
    for (const type of ['gesturestart', 'gesturechange', 'gestureend'])
        target.addEventListener(type, prevent, { capture: true, passive: false });
    const multiTouch = (event) => { if (event.touches.length > 1)
        prevent(event); };
    target.addEventListener('touchstart', multiTouch, { capture: true, passive: false });
    target.addEventListener('touchmove', multiTouch, { capture: true, passive: false });
    target.addEventListener('wheel', event => { if (event.ctrlKey || event.metaKey)
        prevent(event); }, { capture: true, passive: false });
    target.addEventListener('keydown', event => {
        if ((event.key === 'F11' && Date.now() >= allowExitUntil) || ((event.ctrlKey || event.metaKey) && ['+', '=', '-', '_', '0'].includes(event.key)))
            prevent(event);
    }, { capture: true });
}
//# sourceMappingURL=kioskInteractions.js.map